import React from 'react'

const CardList = props => (
  <ul className='card-list bottom-space'>{props.children}</ul>
)

export default CardList



// WEBPACK FOOTER //
// ./src/ui/cards/card-list.js